import React, { Component } from 'react';

class ReturnPage extends Component {
    state = {
        customernumber: '',
        saison: ''
    };

    handleInputChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        console.log(this.state);
    }

    render() {
        return (
            <div className="retoure-online">
                <h2>Retoure online</h2>
                <p>Herzlich willkommen bei der Retoure der Firma Lindt GmbH.</p>
                
                <form onSubmit={this.handleSubmit}>
                    <label>
                        Kundennummer:
                        <input 
                            type="text" 
                            name="customernumber" 
                            value={this.state.customernumber} 
                            onChange={this.handleInputChange} 
                        />
                    </label>

                    <label>
                        Saison:
                        <select name="saison" value={this.state.saison} onChange={this.handleInputChange}>
                            <option value="">--Wählen Sie eine Saison--</option>
                            <option value="ostern">Ostern</option>
                            <option value="herbstHalloween">Herbst/Halloween</option>
                            <option value="weihnachten">Weihnachten</option>
                        </select>
                    </label>

                    {/* Add other input fields as needed */}

                    <button type="submit">Weiter zur Retoure</button>
                </form>

                {/* Add other elements as needed */}
            </div>
        );
    }
}

export default ReturnPage;


// WEBPACK FOOTER //
// ./src/pages/returnCheckout/ReturnPage.js